<template>
  <div class="space-y-2">
    <div v-if="title" class="font-bold">
      {{ title }}
    </div>
    <div
      v-if="options && options.length"
      class="flex gap-y-2 gap-x-6"
      :class="isColumnView && 'flex-col'"
    >
      <template v-for="option in options" :key="option.value">
        <label class="cursor-pointer">
          <input
            v-model="value"
            type="radio"
            class="cursor-pointer"
            :value="option.value"
            @input="onInput"
          />
          {{ option.label }}
        </label>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { OptionInterface } from './use-simple-input'

interface PropsInterface {
  title?: string
  modelValue: string | number
  options: OptionInterface[]
  isColumnView?: boolean
}

const props = withDefaults(defineProps<PropsInterface>(), {
  title: '',
  modelValue: '',
  options: () => [],
  isColumnView: true,
})

const emit = defineEmits(['update:modelValue', 'input'])

const value = computed({
  get() {
    return props.modelValue
  },
  set(newValue) {
    emit('update:modelValue', newValue)
    emit('input')
  },
})
</script>

<style scoped>
input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  border-radius: 50%;
  width: 16px;
  height: 16px;

  border: 1px solid #000000;
  transition: 0.2s all linear;
  outline: none;
  margin-right: 5px;

  position: relative;
  top: 2px;
}

input:checked {
  border: 4px solid #0d65d8;
}
</style>
